import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';
import { BlueBgColor, HeadingBlue } from '../../../../../cra/src/styling/theme';

export const Wrapper = styled.section`
  padding: 40px 0;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 50px 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 55px 0;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 65px 0;
  }
`;

export const ContentWrap = styled.section`
  grid-column: 2/ 12;
`;

export const HeadingText = styled.div`
  width: 100%;
  font-size: 18px;
  line-height: 30px;
  font-weight: 400;
  color: ${HeadingBlue};
  text-align: center;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 22px;
    line-height: 40px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    line-height: 48px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 24px;
    line-height: 64px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 30px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 40px;
  }
`;

export const BlueBg = styled.div`
  background-color: ${BlueBgColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow-x: hidden;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 0 32px;
  }
`;

export const SectionContainer = styled.div`
  width: 90%;
  padding: 24px 0 4px 0;

  @media ${breakpointsMinWidth.desktopSm} {
    width: 80%;
    padding: 32px 0 4px 0;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 80%;
    padding: 40px 0 4px 0;
  }
`;

export const GridSectionWrap = styled.div`
  margin-top: 24px;
  display: grid;
  grid-column-gap: 40px;
  justify-items: center;

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: 42% 1fr;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin-top: 32px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin-top: 44px;
  }
`;
